import { VpButton } from '@vtmn-play/react'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ANALYTICS_EVENTS, trackAnalyticsEvent } from '@/services/analytics'
import gameUrl from './Decathnosaure.html?url'
import './access-denied-page.scss'

export function AccessDeniedPage() {
  const { t } = useTranslation()
  const gameFrameRef = useRef<HTMLIFrameElement>(null)
  const [isGameOpen, setIsGameOpen] = useState(false)

  useEffect(() => {
    const handleGameMessage = (event: MessageEvent) => {
      if (
        event.origin !== window.location.origin
        || event.source !== gameFrameRef.current?.contentWindow
        || typeof event.data !== 'object'
        || event.data === null
        || event.data.type !== 'decathnosaure_game_over'
        || !Number.isFinite(event.data.score)
        || !Number.isFinite(event.data.bestScore)
      ) {
        return
      }

      trackAnalyticsEvent(ANALYTICS_EVENTS.DECATHNOSAURE_GAME_OVER, {
        score: Math.max(0, Math.floor(event.data.score)),
        best_score: Math.max(0, Math.floor(event.data.bestScore)),
      })
    }

    window.addEventListener('message', handleGameMessage)

    return () => window.removeEventListener('message', handleGameMessage)
  }, [])

  return (
    <main data-testid="access-denied-page" className={`access-denied-page${isGameOpen ? ' access-denied-page--game' : ''}`}>
      <div className="access-denied-page-content">
        {isGameOpen
          ? (
              <div className="access-denied-page-game-view">
                <VpButton variant="secondary" onClick={() => setIsGameOpen(false)}>
                  {t('access-denied-page.back')}
                </VpButton>
                <iframe
                  ref={gameFrameRef}
                  className="access-denied-page-game"
                  src={gameUrl}
                  title="Decath'nosaur"
                />
              </div>
            )
          : (
              <>
                <h1 className="access-denied-page-message">
                  <span>{t('access-denied-page.title')}</span>
                  {' '}
                  <span>
                    {t('access-denied-page.subtitle')}
                    {' '}
                    <strong>{t('access-denied-page.date')}</strong>
                  </span>
                </h1>
                <div className="access-denied-page-invitation">
                  <p>{t('access-denied-page.invitation')}</p>
                  <VpButton onClick={() => setIsGameOpen(true)}>
                    {t('access-denied-page.play')}
                  </VpButton>
                </div>
              </>
            )}
      </div>
    </main>
  )
}

export default AccessDeniedPage
